import { render, staticRenderFns } from "./CardVideo.vue?vue&type=template&id=48c288b0&"
import script from "./CardVideo.vue?vue&type=script&lang=js&"
export * from "./CardVideo.vue?vue&type=script&lang=js&"
import style0 from "./CardVideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports